import { api } from '@/components/Functional/lib/request'
import { logger } from '@/components/Functional/utils/logger'
import type { OcrScanRequest } from '@/schemas/v2'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

/**
 * OCR 補填申請 (v2)
 * POST /api/v2/ocr/scan/request
 */
export async function postOcrScanRequest(body: OcrScanRequest, options?: FetchOptions): Promise<void> {
  const url = `${BASE}/api/v2/ocr/scan/request`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'OCR 補填申請 fetch 開始' })
  try {
    await api.post<void>(url, body, options)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
